import React from 'react'
import LandingPage from './LandingPage'

const index = () => {
  return (
    <div>
      <LandingPage />
    </div>
  )
}

export default index
